import { Component, OnInit, ViewContainerRef, OnDestroy } from '@angular/core';
import { NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';
import { BikesUsageService } from '../../statistics/bikes-usage.service';
import { ParametersService } from '../../services/parameters.service';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-bike-usage',
  templateUrl: './bike-usage.component.html',
  styleUrls: ['./bike-usage.component.css'],
  providers: [NgbPopoverConfig]
})
export class BikeUsageComponent implements OnInit, OnDestroy {

  /* Values to display on the dashboard */
  inUseTotal;
  inCirculationTotal;
  brokenDownTotal;
  underMaintainanceTotal;

  /* details values to display  in popover */
  inUseDetails = [];
  inCirculationDetails = [];
  brokenDetails = [];
  underMaintainanceDetails = [];

  /* loading indicator */
  loaded = false;
  inUseLoaded = false;
  inUseHover = false;
  inCirculationLoaded = false;
  inCirculationHover = false;
  brokenLoaded = false;
  brokenHover = false;
  underMaintainanceLoaded = false;
  underMaintainanceHover = false;

  subscription: Subscription;

  constructor(
    private bikeUsageService: BikesUsageService,
    private config: NgbPopoverConfig,
    private parameterService: ParametersService) {

    // popovers configuration
    config.placement = "right";
    config.triggers = "hover";
    config.container = "body";
  }

  /**
   * Get values to display on the dashboard
   */
  ngOnInit() {
    this.bikeUsageService.getBikeUsageStats().subscribe(stats => {
      this.inUseTotal = stats.countAvailableBike;
      this.inCirculationTotal = stats.countOnTheRoad;
      this.underMaintainanceTotal = stats.countUnderMaintenance;
      this.brokenDownTotal = stats.countOutOfOrder;
      this.loaded = true;
    });

    // Observable interval, to refresh data programmatically
    this.subscription = Observable.interval(this.parameterService.dashboardRefreshInterval).subscribe(() => this.refreshData(false));
  }

  /**
   * When component destroy, unsubscribe from the observable to avoid continous data loading
   */
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getInUseDetails(trigeredByMouseHover: boolean): void {
    if (!this.inUseLoaded || !trigeredByMouseHover) {
      this.bikeUsageService.getInUseBikeStats().subscribe(data => {
        this.inUseDetails = data.availableBikes;
        this.inUseLoaded = true;
      })
    }
  }

  getInCirculationDetails(trigeredByMouseHover: boolean): void {
    if (!this.inCirculationLoaded || !trigeredByMouseHover) {
      this.bikeUsageService.getinCirculationBikeStats().subscribe(data => {
        this.inCirculationDetails = data.onTheRoadBikes;
        this.inCirculationLoaded = true;
      });
    }
  }

  getBrokenDownDetails(trigeredByMouseHover: boolean): void {
    if (!this.brokenLoaded || !trigeredByMouseHover) {
      this.bikeUsageService.getBrokenDownBikesStats().subscribe(data => {
        this.brokenDetails = data.outOfOrderBikes;
        this.brokenLoaded = true;
      });
    }
  }

  getMaintainanceDetails(trigeredByMouseHover: boolean): void {
    if (!this.underMaintainanceLoaded || !trigeredByMouseHover) {
      this.bikeUsageService.getMaintainanceStats().subscribe(data => {
        this.underMaintainanceDetails = data.underMaintenanceBikes;
        this.underMaintainanceLoaded = true;
      })
    }

  }

  /**
   * On refresh button click or called on a certain interval
   */
  refreshData(trigeredByClick: boolean): void {

    // if trigered by click => show loading spinner
    if (trigeredByClick) {
      this.loaded = false;
    }

    this.inUseLoaded = false;
    this.inCirculationLoaded = false;
    this.brokenLoaded = false;
    this.underMaintainanceLoaded = false;

    if (this.inUseHover) {
      this.getInUseDetails(false);
    }

    if (this.inCirculationHover) {
      this.getInCirculationDetails(false);
    }

    if (this.brokenHover) {
      this.getBrokenDownDetails(false);
    }

    if (this.underMaintainanceHover) {
      this.getMaintainanceDetails(false);
    }


    this.bikeUsageService.getBikeUsageStats().subscribe(stats => {
      this.inUseTotal = stats.countAvailableBike;
      this.inCirculationTotal = stats.countOnTheRoad;
      this.underMaintainanceTotal = stats.countUnderMaintenance;
      this.brokenDownTotal = stats.countOutOfOrder;
      this.loaded = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/bike-usage/bike-usage.component.ts